import React from 'react';
import { Link } from 'react-router-dom';
import workProjects from '../data/workProjects';

const ArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor" className="icon">
    <path fillRule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z" />
  </svg>
);

const Works = ({ language = 'en' }) => {
  return (
    <section id="work" className="service__section pt-120 pb-60">
      <div className="container">
        <div className="project__head text-center mb-60">
          <span
            className="common__sub aos-init aos-animate"
            data-aos="fade-down"
            data-aos-duration="1000"
          >
            {language === 'zh' ? '我們的成果' : 'Our Work'}
          </span>
          <h2
            className="fw-500 aos-init aos-animate"
            data-aos="fade-up"
            data-aos-duration="1200"
          >
            {language === 'zh' ? '完成項目' : 'Completed Projects'}
          </h2>
        </div>

        <div className="project__wrapone">
          {workProjects.map((project) => {
            const title = language === 'zh' ? project.titleZh : project.titleEn;
            const category = language === 'zh' ? project.categoryZh : project.categoryEn;
            const coverImg = project.images[0];
            return (
              <div
                key={project.id}
                className="project__item aos-init aos-animate"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <div className="thumb mb-30 imgc" style={{ overflow: 'hidden', borderRadius: '10px' }}>
                  <Link to={`/#work/${project.id}`} style={{ display: 'block', lineHeight: 0 }}>
                    <img
                      src={coverImg.src}
                      alt={coverImg.alt}
                      style={{
                        width: '100%',
                        height: '280px',
                        objectFit: 'cover',
                        display: 'block',
                        borderRadius: '10px',
                        transition: 'transform 0.4s ease',
                      }}
                      onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                      onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                    />
                  </Link>
                </div>
                <div className="content d-flex align-items-center justify-content-between gap-2">
                  <Link className="left__cont" to={`/#work/${project.id}`} style={{ textDecoration: 'none' }}>
                    <span className="base mb-2 mb-xxl-3 d-block text-uppercase">{category}</span>
                    <h3>{title}</h3>
                  </Link>
                  <Link to={`/#work/${project.id}`} className="common__icon imgc">
                    <ArrowIcon />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Works;

